export default function SearchIcon({ label = 'Vyhledat', ...restProps }) {
	return (
		<svg
			version='1.1'
			viewBox='0 0 20 20'
			aria-label={label}
			focusable={false}
			xmlns='http://www.w3.org/2000/svg'
			{...restProps}
		>
			<path
				fill='currentColor'
				d='M 8.66201,15.27201 C 5.017,15.27201 2.054,12.30701 2.054,8.66301 2.054,5.018 5.017,2.053 8.66201,2.053 c 3.645,0 6.609,2.965 6.609,6.61001 0,3.644 -2.964,6.609 -6.609,6.609 z m 10.909,2.122 c -0.713,-0.744 -1.525,-1.392 -2.366,-2.009 -0.419,-0.31 -0.859,-0.599 -1.313,-0.876 -0.188,-0.106 -0.378,-0.212 -0.57,-0.315 1.249,-1.501 2.003,-3.43 2.003,-5.531 C 17.32501,3.886 13.43801,0 8.66201,0 3.886,0 0,3.886 0,8.66301 c 0,4.776 3.886,8.663 8.66201,8.663 2.111,0 4.046,-0.761 5.551,-2.021 0.101,0.191 0.205,0.38 0.309,0.568 0.274,0.455 0.561,0.896 0.869,1.317 0.614,0.844 1.256,1.659 1.997,2.377 0.592,0.572 1.538,0.58 2.137,0.006 0.615,-0.589 0.635,-1.565 0.046,-2.179 z'
			/>
		</svg>
	);
}
